var CartAutocompleteComponent = Vue.component('cart-auto-complete', {
    extends: AutocompleteComponent,
    methods: {
        onProductClick($event, product) {
            $('body').addClass('disabled-up-sell');

            $event.preventDefault();

            this.$store.dispatch('addCartItem', {
                product_id: product.id,
                product_variation_id: product.product_variation_id,
                module_data: product.module_data,
                quantity: 1
            });

            this.isOpen = false;
            this.keyword = '';
        }
    }
});
